// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3TQna","filesListContainer":"PosDisputesFiles_filesListContainer__2miXp","filesButton":"PosDisputesFiles_filesButton__14FdG"};